import { jsx as _jsx } from "react/jsx-runtime";
import { PageWrapper } from 'libs.react';
import { DashboardsList } from '../../components/dashboards_list/dashboards_list.component';
const DashboardsListPage = () => {
    return (_jsx(PageWrapper, { children: _jsx(DashboardsList, {}) }));
};
export default DashboardsListPage;
